<template>
  <v-container fluid>
    <v-row align="center">
      <v-col class="d-flex flex-row align-center flex-wrap">
        <h1>Reports Hub</h1>
        <v-progress-circular indeterminate color="green" v-if="loading" class="ml-3" />
        <v-spacer />
        <v-text-field
          v-model="search" dense outlined hide-details clearable prepend-inner-icon="mdi-magnify"
          label="Search reports" style="max-width: 320px"
        />
        <v-switch
          v-if="isSuper" v-model="showDrafts" dense inset hide-details class="ml-4 mt-0 pt-0" label="Show drafts & hidden"
          @change="onToggleDrafts"
        />
        <v-btn v-if="isSuper" class="ml-2" outlined to="/superadmin/report-builder">
          <v-icon left>mdi-wrench</v-icon>Builder
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h2 class="red--text">THIS IS STILL UNDER DEVELOPMENT SO TAKE CAUTION WITH USING THESE REPORTS AND ITS DATA.</h2>
      </v-col>
    </v-row>

    <v-alert v-if="!loading && !filtered.length" type="info" outlined>
      {{ search ? 'No reports match your search.' : 'No reports are available to you yet.' }}
    </v-alert>

    <div v-for="cat in filtered" :key="cat.id" class="mb-6">
      <div class="d-flex align-center mb-2">
        <v-icon v-if="cat.icon" class="mr-2">{{ cat.icon }}</v-icon>
        <h2 class="text-h6">{{ cat.name }}</h2>
        <span class="ml-2 grey--text text-caption">{{ cat.reports.length }}</span>
      </div>
      <p v-if="cat.description" class="grey--text text--darken-1">{{ cat.description }}</p>
      <v-row dense>
        <v-col v-for="r in cat.reports" :key="r.key" cols="12" sm="6" md="4" lg="3">
          <v-card outlined hover height="100%" :to="`/report-hub/${r.key}`" class="d-flex flex-column">
            <v-card-title class="text-subtitle-1 d-flex align-start">
              <span class="flex-grow-1">{{ r.name }}</span>
              <v-icon v-if="r.verification && r.verification.ok" small color="success" title="Verified by tests">mdi-check-decagram</v-icon>
              <v-chip v-if="r.visibility !== 'published'" x-small class="ml-1">{{ r.visibility }}</v-chip>
            </v-card-title>
            <v-card-text class="flex-grow-1 pt-0">{{ r.description }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'ReportsHubIndex',
  data () {
    return { loading: false, categories: [], search: '', showDrafts: false }
  },
  computed: {
    ...mapGetters(['getEndpoint', 'isAllowed']),
    isSuper () { return this.isAllowed('rbBuilder', 'r') },
    filtered () {
      const q = (this.search || '').trim().toLowerCase()
      if (!q) return this.categories
      return this.categories
        .map((c) => ({
          ...c,
          reports: c.reports.filter((r) =>
            [r.name, r.description, c.name, ...(r.tags || [])].join(' ').toLowerCase().includes(q))
        }))
        .filter((c) => c.reports.length)
    }
  },
  async mounted () {
    try { this.showDrafts = localStorage.getItem('rb:showDrafts') === '1' } catch (e) { /* storage unavailable */ }
    await this.load()
  },
  methods: {
    async load () {
      try {
        this.loading = true
        // builders only get drafts / hidden reports in the list when they switch it on
        const res = await axios.get(`${this.getEndpoint}/api/rb-viewer`, { params: this.showDrafts ? { includeUnpublished: 1 } : {} })
        this.categories = res.data.data
      } finally {
        this.loading = false
      }
    },
    async onToggleDrafts () {
      try { localStorage.setItem('rb:showDrafts', this.showDrafts ? '1' : '0') } catch (e) { /* ignore */ }
      await this.load()
    }
  }
}
</script>
